<template>
    <section id="result-search-page">
        <div :class="containerClasses">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>Recommended</h2>
                        </div>
                    </div>
                    <div class="bottom space-between">
                        <div class="left">
                            <select class="per-page" v-model="perPage" @change="onFilterChange('perPage', 'per_page')">
                                <option v-for="option in per_page_options" :value="option.value">
                                    {{ option.text }}
                                </option>
                            </select>
                            <select class="per-row" v-model="perRow" @change="onFilterChange('perRow', 'per_row')">
                                <option v-for="option in vehicles_in_row_options" :value="option.value">
                                    {{ option.text}}
                                </option>
                            </select>
                            <el-select
                                v-if="$userIsAdmin()"
                                    v-model="recommendedBy"
                                    filterable
                                    placeholder="Filter recommended by"
                                    @change="onFilterChange('recommendedBy', 'recommended_by')"
                            >
                                <el-option label="All" value="all"/>
                                <el-option label="Mine" :value="loggedInUser.id"/>
                                <el-option
                                        v-for="user in recommendedUsers"
                                        :key="user.id"
                                        :label="user.label"
                                        :value="user.id">
                                </el-option>
                            </el-select>
                            <select v-model="dateFilter" @change="onFilterChange('dateFilter', 'date')">
                                <option :value="null">Filter by Date</option>
                                <template v-for="date in dateOptions">
                                    <option :value="date.value" :selected="date.value == dateFilter">{{date.label}}</option>
                                </template>
                            </select>
                            <select v-model="addedHourFilter" @change="onFilterChange('addedHour', 'added_hour')">
                                <option :value="null">Filter by recommended time</option>
                                <template v-for="addedHour in addedFilterOptions">
                                    <option :value="addedHour.value" :selected="addedHour.value == addedHourFilter">{{addedHour.label}}</option>
                                </template>
                            </select>

                        </div>
                        <div class="right">
                            <select name="sorting" id="sorting" v-model="sortOrderBy" @change="onFilterChange('sortOrderBy', 'sort_order_by')">
                                <option v-for="(data, value) of order_options" :value="value">
                                    {{data.text}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div>
                            <span class="showing" v-if="total > 0">
                                <strong>Showing</strong>
                                <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                                results
                            </span>
                    </div>
                </div>
                <div class="container-results" id="container-results">
                    <template v-if="recommendedVehicles && recommendedVehicles.length">
                        <Vehicle v-for="vehicle of recommendedVehicles" :key="vehicle.api_id"
                                 :vehicle="vehicle"
                                 :style=resultBlockWidth
                                 priceField="start_price"
                                 :selected="selectedVehicles.indexOf(vehicle.api_id) !== -1"
                                 @select="selectVehicle"
                                 @tagPopupModal="tagPopupModal">
                        </Vehicle>
                        <div class="single-result-search none" v-for="vehicle of [1,2,3,4,5,6,7,8]"></div>
                    </template>
                    <div v-else class="col-md-12">
                        <template v-if="loading">
                            Loading...
                        </template>
                        <template v-else>
                            No recommended vehicles found.
                        </template>
                    </div>
                </div>
                <div class="bottom-container-result d-flex flex-wrap justify-content-end">
                    <b-pagination
                            v-if="total > 0"
                            :total-rows="total"
                            v-model="current_page"
                            :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
        <favourite-tag-modal
            :vehicleId=vehicle_id
            v-model="favListModalOpen"
            @changed="onTagChanged"
        ></favourite-tag-modal>
    </section>
</template>
<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import {addPageUrlParam, objLookup, setVehicleNextPrev} from '../../util/common'
    import Router from '../../thirdparty/Ziggy/route.js';
    import moment from 'moment';
    import Vehicle from '../Common/Vehicle';
    export default {
        components: {
            Vehicle
        },
        async created(){
            if (this.$route.query && this.$route.query.per_page) {
                this.perPage = parseInt(this.$route.query.per_page)
            }
            if (this.$route.query && this.$route.query.per_row) {
                this.perRow = parseInt(this.$route.query.per_row)
            }
            if (this.$route.query && this.$route.query.page) {
                this.setPage(parseInt(this.$route.query.page))
            }
            if (this.$userIsAdmin() && this.$route.query && this.$route.query.recommended_by) {
                if (this.$route.query.recommended_by === 'all') {
                    this.recommendedBy = this.$route.query.recommended_by
                } else {
                    this.recommendedBy = parseInt(this.$route.query.recommended_by)
                }
            }
            if (this.$route.query && this.$route.query.date) {
                this.dateFilter = this.$route.query.date
            }
            if (this.$route.query && this.$route.query.added_hour) {
                this.addedHourFilter = this.$route.query.added_hour
            }
            if (this.$route.query && this.$route.query.sort_order_by && this.order_options[this.$route.query.sort_order_by]) {
                this.sortOrderBy = this.$route.query.sort_order_by
                let value = this.$route.query.sort_order_by
                if (this.order_options[value]) {
                    this.sort_by = this.order_options[value].field;
                    this.sort_asc = this.order_options[value].order_asc;
                }
            }
            this.$store.dispatch('stock_nextprev/checkStack');
            this.$store.dispatch('stock_nextprev/checkListReturn', this.$route.query.state_key || null)
            this.$store.dispatch('favourites/getIds');
            this.getData({});
            this.getRecommendedByUsers()
        },
        data() {
            return {
                showSearchBidBox: true,
                favListModalOpen: false,
                sort_by: 'auction_date',
                sort_asc: true,
                loading: false,
                vehicle_id: null,
                selected_search: null,
                dateFilterToday: window.moment().format('YYYY-MM-DD'),
                dateFilter: window.moment().format('YYYY-MM-DD'),
                addedHourFilter: null,
                recommendedBy: this.$userIsAdmin() ? this.loggedInUser.id : 'all',
                recommendedUsers: [],
                selectedVehicles: [],
                perPage: 2000,
                perRow: 5,
                fields: [
                    {label: 'Created Date',      key: 'recommendation.created_at'},
                    {label: 'Message',         key: 'recommendation.message'},
                    {label: 'View Vehicle List',         key: 'link'},
                ],
                sortOrderBy: 'auction_date',
                order_options: {
                    make: {text: 'Sort by make', field: 'make', order_asc: true},
                    price_asc: {text: 'Price low to high', field: 'start_price', order_asc: true},
                    price_desc: {text: 'Price high to low', field: 'start_price', order_asc: false},
                    auction_date: {text: 'Auction time', field: 'auction_date', order_asc: false},
                    year_asc: {text: 'Year low to high', field: 'year', order_asc: true},
                    year_desc: {text: 'Year high to low', field: 'year', order_asc: false},
                    condition: {text: 'Auction grade high to low', field: 'condition', order_asc: false},
                    recommended_desc: {text: 'Latest recommended', field: 'recommended_at', order_asc: false},
                    recommended_asc: {text: 'Oldest recommended', field: 'recommended_at', order_asc: true},
                },
                vehicles_in_row_options: [
                    {value: 0, text: 'FULL WIDTH'},
                    {value: 5, text: '5 per row'},
                    {value: 6, text: '6 per row'},
                ],
                per_page_options: [
                    {value: 50, text: '50 per page'},
                    {value: 100, text: '100 per page'},
                    {value: 250, text: '250 per page'},
                    {value: 500, text: '500 per page'},
                    {value: 1000, text: '1000 per page'},
                    {value: 2000, text: '2000 per page'},
                ],
                addedFilterOptions: [
                    {label: 'Recommended the last 30 mins', value: 'last_30mins'},
                    {label: 'Recommended the last hour', value: 'last_hour'},
                    {label: 'Recommended the last 2 hours', value: 'last_2hours'},
                    {label: 'Recommended the last 3 hours', value: 'last_3hours'},
                    {label: 'Recommended the last 4 hours', value: 'last_4hours'},
                    {label: 'Recommended the last 6 hours', value: 'last_6hours'},
                    {label: 'Recommended the last 8 hours', value: 'last_8hours'},
                ],
                bid: '',
                boxLeft: false,
                priceField: 'start_price',
            }
        },
        computed: {
            ...mapState({
                recommendedVehicles: state => state.recommended.all,
                per_page: state => state.recommended.per_page,
                from: state => state.recommended.from,
                to: state => state.recommended.to,
                last_page: state => state.recommended.last_page,
                total: state => state.recommended.total,
                favourites: state => state.favourites.ids,
            }),
            dateOptions() {
                let dates = [];
                let date = moment().subtract(1, 'd');
                dates.push({label: 'Yesterday - '+date.format('ddd Do MMM'), value: date.format('YYYY-MM-DD')});
                date.add(1, 'd');
                dates.push({label: 'Today - '+date.format('ddd Do MMM'), value: date.format('YYYY-MM-DD')});
                date.add(1, 'd');
                dates.push({label: 'Tomorrow - '+date.format('ddd Do MMM'), value: date.format('YYYY-MM-DD')});
                return dates;
            },
            containerClasses() {

                let classes = ['container'];
                if (this.perRow === 0) {
                    classes.push('full-width');
                } else if (this.perRow === 5) {
                    classes.push('per-5');
                } else if (this.perRow === 6) {
                    classes.push('per-6');
                }
                return classes.join(' ');
            },
            current_page: {
                get(){
                    return this.$store.getters['recommended/current_page'];
                },
                set(value){
                    this.$store.commit('recommended/setPage', value)
                    addPageUrlParam(value, this.$router)
                    this.getData({page: value});
                }
            },
            resultBlockWidth() {
                if (this.perRow) {
                    return {
                        width: 'calc(' + 100 / this.perRow + '% - 5px)'
                    }
                }
                return '';
            },
            pageParam () {
                return this.$route.query.page
            }
        },
        methods: {
            ...mapActions('favourites', [
                'toggleFavourite'
            ]),
            ...mapMutations({
                setPage: 'recommended/setPage',
            }),
            ...mapActions({
                addToNextPrevStack: 'auction_nextprev/addToStack',
                translateGrades: 'auction_search/translateGrades',
            }),
            onTagChanged(data){
                let selected = this.selectedVehicles.indexOf(data.vehicle_id);
                if (data.removed) {
                    if (data.tags_left === 0 && selected !== -1) {
                        this.selectedVehicles.splice(selected, 1);
                    }
                } else {
                    if (selected === -1) {
                        this.selectedVehicles.push(data.vehicle_id);
                    }
                }
            },
            async getData(params) {
                this.loading = true;
                try {
                    let data = Object.assign({
                        sort_by: this.sort_by,
                        sort_asc: this.sort_asc,
                        filter_by_date: this.dateFilter,
                        filter_by_added: this.addedHourFilter,
                        filter_recommended_by: this.recommendedBy === 'all' ? null : this.recommendedBy,
                        page: this.current_page,
                        per_page: this.perPage,
                    }, params);
                    if (this.$route.query.user_id) {
                        data.user_id = this.$route.query.user_id
                    }
                    await this.$store.dispatch('recommended/getMyRecommendation', data);
                    // Disabled for now because it's costing alot of money
                    //this.translateGrades(this.recommendedVehicles)
                    let ids = [];
                    let favs = [];
                    this.recommendedVehicles.forEach(v => {
                        ids.push(v.api_id)
                        if (v.is_favourite) {
                            favs.push(v.api_id)
                        }
                    })
                    this.selectedVehicles = favs
                    this.addToNextPrevStack({ids})
                    this.$nextTick(() => {
                        this.loading = false;
                    })
                } catch (e) {
                    this.loading = false;
                    console.warn(e);
                }

            },
            objLookup(obj, key){
                return objLookup(obj, key);
            },
            displayAuctionHouse(orig_name) {
                let auctionName = '';
                let name = orig_name.replace(/[^a-zA-Z]/, ' ').replace(/\s{2,}/, ' ');
                // Auction name split in an array
                if (name.indexOf(' ') !== -1) {
                    let arrayName = name.split(' ');
                    // Compose the auction name 2 chars for the first word and 3 chars for the second word.
                    auctionName = arrayName[0].slice(0, 2) + '-' + arrayName[1].slice(0, 3)
                } else if (name.length > 2) {
                    auctionName = name.slice(0, 2);
                }
                return auctionName;
            },
            tagPopupModal(vehicle_id) {
                this.favListModalOpen = true;
                this.vehicle_id = vehicle_id;
                this.$store.dispatch('favouriteTags/maybeGetTags', {});
            },
            selectVehicle(vehicle) {
                let selected = this.selectedVehicles.indexOf(vehicle.api_id);
                if (selected !== -1) {
                    this.selectedVehicles.splice(selected, 1);
                    this.$store.dispatch('favourites/removeFavourite', vehicle.api_id);
                } else {
                    this.selectedVehicles.push(vehicle.api_id);
                    this.$store.dispatch('favourites/addFavourite', vehicle.api_id);
                }
            },
            isFavourite(id, api_id) {
                let isFav = false;
                if (this.favourites) {
                    this.favourites.forEach(fav => {
                        if (!isFav && (fav === id || fav === api_id)) {
                            isFav = true;
                        }
                    });
                }
                return isFav;
            },
            convertEquipment(item) {
                let html = item.replace(/ /g, ', ');
                html = html.toUpperCase();
                return html;
            },
            onFilterChange(field, url_key) {
                this.$nextTick(() => {
                    if (field === 'sortOrderBy') {
                        let value = this[field]
                        if (this.order_options[value]) {
                            this.sort_by = this.order_options[value].field;
                            this.sort_asc = this.order_options[value].order_asc;
                        }
                    }
                    let query = {}
                    query[url_key] = this[field]
                    this.$updateUrlQuery(query)
                    if (this.current_page !== 1) {
                        this.current_page = 1; //this triggers getData()
                    } else {
                        this.getData();
                    }
                });
            },
            getDate(data) {
                return window.moment(data).format(this.defaultMomentDateFormat())
            },
            getAllVehicleImages(vehicle) {
                if (!vehicle.load_images) {
                    vehicle.load_images = true;
                }
            },
            convertCurrency(price) {
                let nzdPrice = Math.round(price / currencyRate['nzd']);
                let jpyPrice = Math.round(price);
                if (jpyPrice > 10000) {
                    jpyPrice = jpyPrice / 1000 + 'k';
                }
                let priceDescription = this.past ? 'Final' : 'Start';
                return `
                    <div class="currency" :data-currency="vehicle.currency" title="$${nzdPrice} NZD">¥</div>
                    <div class="price" title="$${nzdPrice} NZD">${jpyPrice}</div>
                    <div class="start" title="$${nzdPrice} NZD">
                        <div class="currency-name">JPN</div>
                        <div class="start-auction" title="$${nzdPrice} NZD">Start ${priceDescription}</div>
                    </div>
                `;
            },
            setSearchSettings() {
                let data = {
                    recommend_per_page: this.perPage,
                    recommend_per_row: this.perRow,
                    recommend_sort: this.sortOrderBy,
                };
                let url = this.$laravelRoute('set-search-settings');
            },
            async getRecommendedByUsers(){
                let users = []
                let url = this.$laravelRoute('recommended.recommendedByUserList');
                let res = await this.axios.get(url);
                if (res.data && res.data.user_list) {
                    users = res.data.user_list
                }
                this.recommendedUsers = users
            },
        },
        watch: {
            pageParam (value) {
                if (value) {
                    this.$store.commit('recommended/setPage', value)
                    this.getData()
                }
            }
        },
        mounted() {
            if (!this.$route.query.page) {
                addPageUrlParam(this.current_page, this.$router, true)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/MyRecommendations/RecommendedPage.vue